import { render } from "./CSectionSubtitle.vue?vue&type=template&id=09c5c990&scoped=true"
const script = {}

import "./CSectionSubtitle.vue?vue&type=style&index=0&id=09c5c990&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c5c990"]])

export default __exports__